// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Lang
import { nsContract } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.rank
 * @returns {JSX} RenderRank
 */
function RenderRank({ rank }) {

    if (!rank) {
        return <Entity namespace={nsContract} entity={'rank.all'} nowrap />;
    }

    if (rank.includes('_')) {
        const [from, to] = rank.split('_');
        return <Entity namespace={nsContract} entity={'rank.range'} data={{ from: from, to: to }} nowrap />;
    }

    return rank;
}

RenderRank.propTypes = {
    rank: PropTypes.string
};

export default RenderRank;